import DownloadCollection from "./DownloadCollection";

export default DownloadCollection;
